import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'react-hot-toast';
import { Outlet } from 'react-router';

import { NavigationProvider, ThemeProvider } from '@/providers';

import { FallbackComponent, TooltipProvider } from '@/components/common';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const ProvidersLayout = () => (
  <ErrorBoundary FallbackComponent={FallbackComponent}>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <NavigationProvider>
            <Toaster />
            <Outlet />
          </NavigationProvider>
        </TooltipProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ThemeProvider>
  </ErrorBoundary>
);

export { ProvidersLayout };
